import{useEffect as r}from"react";import{useInRouterContext as o,useLocation as t}from"react-router-dom";import e from"./useAnalytics";/**
 * Wrapper component which sends route change events to Firefly Internal Insights.
 *
 * Must be rendered inside of a `<Router>`.
 * @param children
 * @param eventManagerConfiguration
 * @example
 * const App = () => (
 *   <Router>
 *     <LocationTracker eventManagerConfiguration={apiConfig.analytics}>
 *       <MyContent />
 *     </LocationTracker>
 *   </Router>
 * )
 */const n=()=>{const n=o();// useLocation throws an error with unclear wording for our users if you call it outside of a router.
// Given that hooks cannot be called conditionally, that means we can't put it in a try/catch block.
// Better to detect early by trying to read the __RouterContext, and error out if it's not there.
if(!n){throw new Error("Location tracking must be performed from inside a <Router>")}const{pathname:m}=t();const{trackView:c}=e();r(()=>{c(m)},[m,c]);return null};export default n;